// extracted by mini-css-extract-plugin
export default {"container":"ImagesCarouselModal_container__mTwc8","slide":"ImagesCarouselModal_slide__UyPRX"};